export const districtsData = {
    Rawalpindi: [
      "Attock Tehsil",
      "Fateh Jang Tehsil",
      "Hassan Abdal Tehsil",
      "Hazro Tehsil",
      "Jand Tehsil",
      "Pindi Gheb Tehsil",
    ],
    Murree: ["Kotli Sattian Tehsil", "Murree Tehsil"],
    Chakwal: [
      "Chakwal Tehsil",
      "Choa Saidan Shah Tehsil",
      "Kallar Kahar Tehsil",
    ],
    Jhelum: [
      "Dina Tehsil",
      "Jhelum Tehsil",
      "Pind Dadan Khan Tehsil",
      "Sohawa Tehsil",
    ],
    Gujrat: [
      "Gujrat Tehsil",
      "Kharian Tehsil",
      "Sarai Alamgir Tehsil",
      "Jalalpur Jattan Tehsil",
      "Kunjah Tehsil",
    ],
    Wazirabad: ["Wazirabad Tehsil", "Ali Pur Chatta Tehsil"],
    Hafizabad: ["Hafizabad Tehsil", "Pindi Bhattian Tehsil"],
    MandiBahauddin: ["Malakwal Tehsil", "Mandi Bahauddin Tehsil", "Phalia Tehsil"],
    Sialkot: [
      "Daska Tehsil",
      "Pasrur Tehsil",
      "Sambrial Tehsil",
      "Sialkot Tehsil",
    ],
    Narowal: ["Narowal Tehsil", "Shakargarh Tehsil", "Zafarwal Tehsil"],
    Gujranwala: [
      "Gujranwala City Tehsil",
      "Gujranwala Saddar Tehsil",
      "Wazirabad Tehsil",
      "Kamoke Tehsil",
      "Nowshera Virkan Tehsil",
    ],
    Sargodha: [
      "Bhalwal Tehsil",
      "Bhera Tehsil",
      "Kot Momin Tehsil",
      "Sahiwal Tehsil",
      "Sargodha Tehsil",
      "Shahpur Tehsil",
      "Sillanwali Tehsil",
    ],
    Khushab: [
      "Khushab Tehsil",
      "Noorpur Thal Tehsil",
      "Quaidabad Tehsil",
      "Naushera Tehsil (Wadi-e-Soon)",
    ],
    Mianwali: ["Isakhel Tehsil", "Mianwali Tehsil", "Piplan Tehsil"],
    Bhakkar: [
      "Bhakkar Tehsil",
      "Darya Khan Tehsil",
      "Kaloorkot Tehsil",
      "Mankera Tehsil",
    ],
    Chiniot: ["Bhowana Tehsil", "Chiniot Tehsil", "Lalian Tehsil"],
    Faisalabad: [
      "Chak Jhumra Tehsil",
      "Faisalabad City Tehsil",
      "Faisalabad Sadar Tehsil",
      "Jaranwala Tehsil",
      "Samundri Tehsil",
      "Tandlianwala Tehsil",
    ],
    TobaTekSingh: [
      "Gojra Tehsil",
      "Kamalia Tehsil",
      "Pirmahal Tehsil",
      "Toba Tek Singh Tehsil",
    ],
    Jhang: [
      "Jhang Tehsil",
      "Shorkot Tehsil",
      "Ahmadpur Sial Tehsil",
      "Athara Hazari Tehsil",
      "Mandi Shah Jeewna",
    ],
    NankanaSahib: ["Nankana Sahib Tehsil", "Sangla Hill Tehsil", "Shah Kot Tehsil"],
    Sheikhupura: [
      "Ferozewala Tehsil",
      "Muridke Tehsil",
      "Safdarabad Tehsil",
      "Sheikhupura Tehsil",
      "Sharak Pur Tehsil",
    ],
    Lahore: [
      "Lahore Cantonment Tehsil",
      "Lahore City Tehsil",
      "Model Town Tehsil",
      "Raiwind Tehsil",
      "Shalimar Tehsil",
      "Nishtar Tehsil",
      "Wagah Tehsil",
      "Iqbal Town Tehsil",
      "Ravi Tehsil",
      "Saddar Tehsil",
    ],
    Kasur: [
      "Chunian Tehsil",
      "Kasur Tehsil",
      "Kot Radha Kishan Tehsil",
      "Pattoki Tehsil",
    ],
    Okara: ["Depalpur Tehsil", "Okara Tehsil", "Renala Khurd Tehsil"],
    Pakpattan: ["Arifwala Tehsil", "Pakpattan Tehsil"],
    Sahiwal: ["Chichawatni Tehsil", "Sahiwal Tehsil"],
    Khanewal: [
      "Jahanian Tehsil",
      "Kabirwala Tehsil",
      "Khanewal Tehsil",
      "Mian Channu Tehsil",
    ],
    Multan: [
      "Jalalpur Pirwala Tehsil",
      "Multan City Tehsil",
      "Multan Saddar Tehsil",
      "Shujabad Tehsil",
    ],
    Lodhran: ["Dunyapur Tehsil", "Kahror Pacca Tehsil", "Lodhran Tehsil"],
    Vehari: [
      "Jallah jeemTehsil",
      "Burewala Tehsil",
      "Mailsi Tehsil",
      "Vehari Tehsil",
    ],
    Bahawalnagar: [
      "Bahawalnagar Tehsil",
      "Chishtian Tehsil",
      "Fort Abbas Tehsil",
      "Haroonabad Tehsil",
      "Minchinabad Tehsil",
    ],
    Bahawalpur: [
      "Ahmadpur East Tehsil",
      "Bahawalpur City Tehsil",
      "Bahawalpur Saddar Tehsil",
      "Hasilpur Tehsil",
      "Khairpur Tamewali Tehsil",
      "Yazman Tehsil",
    ],
    RahimYarKhan: [
      "Khanpur Tehsil",
      "Liaqatpur Tehsil",
      "Rahim Yar Khan Tehsil",
      "Sadiqabad Tehsil",
    ],
    Muzaffargarh: ["Alipur Tehsil", "Jatoi Tehsil", "Muzaffargarh Tehsil"],
    KotAddu: ["Kot Addu Tehsil", "Chowk Sarwar Shaheed Tehsil"],
    Layyah: ["Chaubara Tehsil", "Karor Lal Esan Tehsil", "Layyah Tehsil"],
    Taunsa: ["Taunsa Tehsil", "Koh-e-Suleman Tehsil", "Vehova Tehsil"],
    DGKhan: [
      "Dera Ghazi Khan Tehsil",
      "Excluded Area D.G. Khan",
      "Kot Chutta Tehsil",
    ],
    Rajanpur: [
      "Rajanpur Tehsil",
      "Rojhan Tehsil",
      "De-Excluded Area Rajanpur Tehsil",
    ],
    // Add remaining provinces or data here if necessary.
  };
  